module.exports = __webpack_public_path__ + "img/3.ced4ce3b.jpg";